import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios"
import axios, { isAxiosError } from "axios"
import { getThreatAnalyticsDomain } from "../constants"

export const threatAnalyticsAxios = axios.create({
  baseURL: getThreatAnalyticsDomain(),
  paramsSerializer: {
    indexes: null,
  },
  fetchOptions: {
    query: {
      retry: (failureCount: number, error: AxiosError) => {
        if (isAxiosError(error) && error.response?.status === 400) {
          return false
        }
        return failureCount < 3
      },
    },
  },
})

/**
 * Axios instance for Orval generated Threat Analytics API client, not meant to be used directly.
 */
export const threatAnalyticsAxiosGenInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  return threatAnalyticsAxios
    .request<T, AxiosResponse<T>>({
      ...config,
      ...options,
    })
    .then(({ data }) => data)
}
